export const POSITIONS_STATUSES = {
	YES: "YES",
	NO: "NO",
	PENDING: "PENDING",
	UNREVIEWED: "UNREVIEWED",
	NOT_ME: "NOT_ME",
};
